import { Box, Heading, Text } from "@radix-ui/themes";
import React, { ReactNode } from "react";

interface IGreetingProps {
  name: string;
  children?: ReactNode;
}

function Greeting({ name, children }: IGreetingProps) {

  return (
    <div className="w-full text-[#545455] mb-2">
      <h1 className="text-2xl font-bold">Hello {name}!</h1>
    </div>
  );
}

export default Greeting;
